import { createAsyncAction, createAction } from "typesafe-actions";
import { User } from "@shared/models";
import { PaginatedResponse, UpdateStatusShape, UserFilter } from "@shared/interfaces";

import { UserActionTypes } from "./constants";
import { CreateUserDto, CreateUserSessionDto, CreateUserSessionSuccess, CreateUserSuccess } from "../interfaces";

export const getUsers = createAsyncAction(
  UserActionTypes.GET_USERS,
  UserActionTypes.GET_USERS_SUCCESS,
  UserActionTypes.GET_USERS_FAILURE,
)<UserFilter, PaginatedResponse<User>, Error>();

export const createUser = createAsyncAction(
  UserActionTypes.CREATE_USER,
  UserActionTypes.CREATE_USER_SUCCESS,
  UserActionTypes.CREATE_USER_FAILURE,
)<CreateUserDto, CreateUserSuccess, Error>();

export const updateUser = createAsyncAction(
  UserActionTypes.UPDATE_USER,
  UserActionTypes.UPDATE_USER_SUCCESS,
  UserActionTypes.UPDATE_USER_FAILURE,
)<CreateUserDto & { id: number }, CreateUserSuccess, Error>();

export const updateUserStatus = createAsyncAction(
  UserActionTypes.UPDATE_USER_STATUS,
  UserActionTypes.UPDATE_USER_STATUS_SUCCESS,
  UserActionTypes.UPDATE_USER_STATUS_FAILURE,
)<UpdateStatusShape, CreateUserSuccess, Error>();

export const createUserSession = createAsyncAction(
  UserActionTypes.CREATE_USER_SESSION,
  UserActionTypes.CREATE_USER_SESSION_SUCCESS,
  UserActionTypes.CREATE_USER_SESSION_FAILURE,
)<CreateUserSessionDto, CreateUserSessionSuccess, Error>();

export const updateUserSession = createAsyncAction(
  UserActionTypes.UPDATE_USER_SESSION,
  UserActionTypes.UPDATE_USER_SESSION_SUCCESS,
  UserActionTypes.UPDATE_USER_SESSION_FAILURE,
)<number, CreateUserSessionSuccess, Error>();

export const setFilter = createAction(UserActionTypes.SET_FILTER)<UserFilter | null>();
export const clearUsers = createAction(UserActionTypes.CLEAR_USERS)();
